import { render, staticRenderFns } from "./Create-User.vue?vue&type=template&id=bb708600"
import script from "./Create-User.vue?vue&type=script&lang=js"
export * from "./Create-User.vue?vue&type=script&lang=js"
import style0 from "./Create-User.vue?vue&type=style&index=0&id=bb708600&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports